import {
  ISimilarOffer,
  getItemBasedSimilarOffers,
  getUserBasedSimilarOffers,
} from '../../api/similar';
import { IThunkActionCreator } from '../index';
import { IGetSimilarOffersResponse } from '../../repositories/monolithPython/v2/get-similar-offers';
import {
  IGetSimilarOffersByOfferIdResponseV2Schema,
} from '../../repositories/monolithPython/entities/schemas/GetSimilarOffersByOfferIdResponseV2Schema';
import {
  IOfferDetailRecommendationSimilarOfferPresenterSchema,
} from '../../repositories/monolithPython/entities/schemas/OfferDetailRecommendationSimilarOfferPresenterSchema';

export enum ESimilarOffersActionsTypes {
  ISimilarOffersReceived = 'ISimilarOffersReceived',
}

export type TModelType = 'userBased' | 'itemBased';

interface ISimilarOffersReceivedAction {
  list: IOfferDetailRecommendationSimilarOfferPresenterSchema[];
  withoutCompetitors: boolean | null;
  modelVersion?: string | null;
  type: ESimilarOffersActionsTypes.ISimilarOffersReceived;
  modelType: TModelType;
}

export function similarOffersReceived(
  data: IGetSimilarOffersByOfferIdResponseV2Schema,
  modelType: TModelType,
): IThunkActionCreator {
  // tslint:disable-next-line:variable-name
  return (dispatch, _getState, _context) => {
    const { similarOffers, modelVersion, withoutCompetitors } = data;
    dispatch<ISimilarOffersReceivedAction>({
      type: ESimilarOffersActionsTypes.ISimilarOffersReceived,
      //tslint:disable-next-line:no-non-null-assertion - строгое наличие similarOffers было проверено выше
      list: similarOffers!,
      withoutCompetitors,
      modelVersion,
      modelType,
    });
  };
}

function requestItemBasedSimilarOffers(offerId: number): IThunkActionCreator {
  return (dispatch, getState, context) => {
    const { pageData: { subdomain } } = getState();

    // обработки ошибок нет, и это нормально — деградируем без показа блока
    return getItemBasedSimilarOffers(context.httpApi, { cianOfferId: offerId }, subdomain)
      .then(({ response, statusCode }) => {
        if (statusCode === 200) {
          const respData = (response as IGetSimilarOffersResponse).data;

          if (respData && respData.similarOffers) {
            dispatch(similarOffersReceived(respData, 'itemBased'));
          }
        }
      });
  };
}

function requestUserBasedSimilarOffers(offerId: number): IThunkActionCreator {
  return (dispatch, getState, context) => {
    const { pageData: { subdomain } } = getState();

    // обработки ошибок нет, и это нормально — деградируем без показа блока
    return getUserBasedSimilarOffers(context.httpApi, { cianOfferId: offerId }, subdomain).then((res) => {
      if (res.statusCode === 200 && res.response.data && res.response.data.similarOffers) {
        dispatch(similarOffersReceived(res.response.data, 'userBased'));
      }
    });
  };
}

export function requestSimilarOffers(offerId: number, modelType: TModelType): IThunkActionCreator {
  return (dispatch) => {
    switch (modelType) {
      case 'userBased':
        return dispatch(requestUserBasedSimilarOffers(offerId));

      case 'itemBased':
        return dispatch(requestItemBasedSimilarOffers(offerId));
    }
  };
}

export interface ISimilarState {
  userBased: {
    list: ISimilarOffer[];
    withoutCompetitors: boolean | null;
    modelVersion: number | string | null;
  };
  itemBased: {
    list: ISimilarOffer[];
    withoutCompetitors: boolean | null;
    modelVersion: number | string | null;
  };
}

const defaultState: ISimilarState = {
  userBased: {
    list: [],
    withoutCompetitors: false,
    modelVersion: 0,
  },
  itemBased: {
    list: [],
    withoutCompetitors: false,
    modelVersion: 0,
  },
};

export function similarOffersReducer(
  state: ISimilarState = defaultState,
  action: ISimilarOffersReceivedAction,
): ISimilarState {
  switch (action.type) {
    case ESimilarOffersActionsTypes.ISimilarOffersReceived:
      return {
        ...state,
        [action.modelType]: {
          list: action.list,
          withoutCompetitors: action.withoutCompetitors,
          modelVersion: action.modelVersion,
        },
      };

    default:
      return state;
  }
}
